import { formatIDR, formatDate, formatSizes, methodLabel, PAY_STATUS } from '../lib/format';

export default function Receipt({ tx, settings, size = 'a4' }) {
  const widthCls = size === '58mm' ? 'w-[58mm] text-[10px]' : size === '80mm' ? 'w-[80mm] text-[11px]' : 'w-full max-w-[640px]';
  const compact = size !== 'a4';
  return (
    <div
      id="receipt-print"
      data-testid="receipt-document"
      className={`${widthCls} mx-auto bg-white border border-border shadow-soft overflow-hidden`}
    >
      <div className="bg-choco px-5 py-4 text-center relative">
        {!compact && (
          <img src="/logo.png" alt="Deyran Gallery" className="w-12 h-12 rounded-full object-cover mx-auto mb-2 ring-1 ring-gold/60" />
        )}
        <p className={`font-display ${compact ? 'text-base' : 'text-2xl'} text-ivory tracking-wide`}>
          {(settings?.business_name || 'DEYRAN GALLERY').toUpperCase()}
        </p>
        <p className="text-gold/80 text-[10px] uppercase tracking-[0.2em] mt-0.5">
          {settings?.tagline || 'Rental Kebaya & Baju Bodo'}
        </p>
        {(settings?.address || settings?.whatsapp) && (
          <p className="text-ivory/50 text-[10px] mt-1">
            {[settings?.address, settings?.whatsapp].filter(Boolean).join(' • ')}
          </p>
        )}
        <div className="absolute bottom-0 inset-x-0 h-0.5 songket-strip opacity-70" />
      </div>

      {tx.status === 'cancelled' && (
        <div data-testid="receipt-cancelled-banner" className="bg-danger/10 text-danger text-center font-bold text-[10px] py-1.5 tracking-[0.25em] uppercase">
          Transaksi Dibatalkan
        </div>
      )}

      <div className={`${compact ? 'px-3 py-3' : 'px-6 py-5'}`}>
        <div className="flex justify-between items-start border-b border-dashed border-gold/40 pb-3">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-mocha">Nota Sewa</p>
            <p className="font-display text-brown-dark font-semibold" data-testid="receipt-tx-number">{tx.transaction_number}</p>
          </div>
          <div className="text-right">
            <p className="text-[10px] uppercase tracking-widest text-mocha">Customer</p>
            <p className="font-semibold text-ink" data-testid="receipt-customer-name">{tx.customer_name}</p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2 py-3 border-b border-dashed border-gold/40 text-center">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-mocha">Ambil</p>
            <p className="font-semibold">{formatDate(tx.pickup_date)}</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-widest text-mocha">Tgl Pakai</p>
            <p className="font-semibold">{formatDate(tx.use_date)}</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-widest text-mocha">Kembali</p>
            <p className="font-semibold text-danger">{formatDate(tx.return_date)}</p>
          </div>
        </div>

        <div className="py-3 border-b border-dashed border-gold/40 space-y-2">
          {tx.rows.map((r, idx) => (
            <div key={idx}>
              <div className="flex justify-between">
                <span>
                  <span className="font-semibold text-brown">{r.product_code}</span> {r.product_name}
                </span>
                <span className="whitespace-nowrap">{formatIDR(r.subtotal)}</span>
              </div>
              <p className="text-[10px] text-mocha">
                {r.qty} pcs ({formatSizes(r.sizes)}) × {formatIDR(r.price_per_pcs)}
                {r.bawahan_name && <> • bawahan: {r.bawahan_name}</>}
              </p>
            </div>
          ))}
        </div>

        <div className="py-3 space-y-1">
          <div className="flex justify-between font-semibold">
            <span>Total ({tx.pcs} pcs)</span>
            <span data-testid="receipt-total">{formatIDR(tx.total)}</span>
          </div>
          <div className="flex justify-between text-mocha">
            <span>Dibayar</span>
            <span data-testid="receipt-paid">{formatIDR(tx.paid)} ({methodLabel(tx.payment_method)})</span>
          </div>
          <div className="flex justify-between font-bold text-brown-dark">
            <span>Sisa Pembayaran</span>
            <span data-testid="receipt-remaining">{formatIDR(tx.remaining)}</span>
          </div>
          <div className="flex justify-between items-center pt-1">
            <span className="text-mocha">Status Pembayaran</span>
            <span
              data-testid="receipt-payment-status"
              className={`px-3 py-0.5 rounded-full text-[10px] font-bold ${PAY_STATUS[tx.payment_status]?.cls || ''}`}
            >
              {PAY_STATUS[tx.payment_status]?.label || tx.payment_status}
            </span>
          </div>
        </div>

        <div className="border-t border-dashed border-gold/40 pt-3 text-center">
          <p className="text-[10px] text-mocha leading-relaxed">
            Mohon kembalikan barang tepat waktu. {settings?.receipt_footer}
          </p>
        </div>
      </div>
    </div>
  );
}
